import { Theme } from '@mui/material';


const DateTimePicker = (theme: Theme) => {
  return {
  };
};

export default DateTimePicker;
